<template>
  <div>
    <x-grid :id="'childGrid'"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            :editable="true"
            :edit-rules="editRules"
            :editConfig="editConfig"
            ref="grid"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>

      </template>
    </x-grid>


  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridChild'
import {GridChildMixin} from "@/utils/GridChildMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"


const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错


//列
const columns = [
  fac.makeColumn("signUserName", "客户名称", 150),
  fac.makeColumn("signUserPhone", "电话", 150),
  fac.makeColumn("strainName", "意向车型", 200),
  fac.makeColumn("wantLevelName", "意向等级", 200),
  fac.makeColumn("orderNum", "订车数量", 100),
]

const rowIdName = 'signId';

//可编辑表格规则 没有特殊要求的不改
const editRules = fac.makeEditRules(columns);

//工具栏按钮 没有可删除
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});
//编辑配置
const editConfig = fac.makeEditConfig();

export default {
  mixins: [GridChildMixin],
  components: {
    // categoryTableModal
  },
  data() {
    return {
      rowIdName,
      toolbarConfig,
      editRules,
      columns,
      editConfig,
      editRowId: -1,
      loyalTypeOptions:[]
    }
  },
  async mounted() {
  },
  methods: {
  }
}
</script>

<style scoped>
/deep/.vxe-toolbar {
  height: 0;
  padding-left: 0
}
</style>
